export default __webpack_public_path__ + "static/media/qr.ea2c3cc9.png";